import { Box, Typography } from '@mui/material';
import { SafeLinkWithFallback } from '@repo/ui/SafeLinkWithFallback';
import { Rating } from './components/Rating';
import { RatingTooltip } from './components/RatingToolTip';

type StackedLayoutProps = {
  reviewLink?: string | null;
  starRating?: number;
  starRatingTooltip?: string;
  hideNumber?: boolean;
  align?: 'start' | 'center' | 'end';
};

export const StackedLayout = ({
  reviewLink,
  starRating,
  starRatingTooltip,
  hideNumber = false,
  align = 'start',
}: StackedLayoutProps) => {
  if (!starRating) return 'Not yet rated';
  return (
    <Box
      data-testid="rating-component"
      sx={{ display: 'flex', alignItems: align, flexDirection: 'column' }}
    >
      <Rating size="19px" gap="6px" value={starRating} />
      <Box>
        {!hideNumber && starRating && starRating !== 0 && (
          <Typography
            variant="textBold"
            sx={{
              mr: 1,
              fontWeight: 700,
              display: 'inline-block',
            }}
          >
            {starRating.toFixed(1)}
          </Typography>
        )}
        <Box sx={{ display: 'inline-block' }}>
          <Typography
            variant="text"
            sx={{
              whiteSpace: 'nowrap',
            }}
          >
            <SafeLinkWithFallback href={reviewLink} target="_blank">
              NerdWallet rating{' '}
            </SafeLinkWithFallback>
            {starRatingTooltip && <RatingTooltip starRatingTooltip={starRatingTooltip} />}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
